import { render, staticRenderFns } from "./Pension.vue?vue&type=template&id=3a942b90&scoped=true&"
import script from "./Pension.vue?vue&type=script&lang=js&"
export * from "./Pension.vue?vue&type=script&lang=js&"
import style0 from "./Pension.vue?vue&type=style&index=0&id=3a942b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a942b90",
  null
  
)

export default component.exports